import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-278a5290"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "assign-overlay" }
const _hoisted_2 = {
  key: 0,
  class: "loader"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Nicht zugewiesen", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Diese Konversation ist dir nicht zugewiesen.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_indicator_circular = _resolveComponent("md-progress-indicator-circular")!
  const _component_transition_fade = _resolveComponent("transition-fade")!
  const _component_md_button = _resolveComponent("md-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_transition_fade, null, {
      default: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_md_progress_indicator_circular)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _hoisted_3,
    _hoisted_4,
    _createVNode(_component_md_button, {
      variant: "filled",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.assign()))
    }, {
      default: _withCtx(() => [
        _createTextVNode("Konversation übernehmen")
      ]),
      _: 1
    })
  ]))
}